// Plugin to append resolution contents to the WYSIWYG editor
const resolution = {
    // plugin name
    name: 'Resolution',

    // add function - It is called only once when the plugin is first run.
    // This function generates HTML to append and register the event.
    // arguments - (core : core object, targetElement : clicked button element)
    add: function (core, targetElement) {

        // Registering a namespace for caching as a plugin name in the context object
        const context = core.context;
        context.resolutions = {
            textElement: null
        };

        // Generate submenu HTML
        // Always bind "core" when calling a plugin function
        let listDiv = this.setSubmenu.call(core);

        // Input tag caching
        context.resolutions.textElement = [
            ...listDiv.getElementsByTagName("SELECT"),
            ...listDiv.getElementsByTagName('INPUT')
        ];

        // You must bind "core" object when registering an event.
        /** add event listeners */
        listDiv.getElementsByTagName('BUTTON')[0].addEventListener('click', this.onClick.bind(core));

        /** append html */
        targetElement.parentNode.appendChild(listDiv);

        // @Required
        // You must add the "submenu" element using the "core.initMenuTarget" method.
        /** append target button menu */
        core.initMenuTarget(this.name, targetElement, listDiv);
    },

    setSubmenu: function () {
        const listDiv = this.util.createElement('DIV');
        const storedAgendas = JSON.parse(sessionStorage.getItem('agendas'));
        let agendas = '';

        Array.isArray(storedAgendas) && storedAgendas.map(
            (agenda) =>
                (agendas += `<option value="${`agenda_${agenda.id}`}">${agenda.label ?? agenda.text}</option>`)
        );


        listDiv.className = 'se-list-layer';
        listDiv.innerHTML = '' +
            `<div class="se-list-inner se-list-align" style="width: 300px;"> 
                <form class="se-submenu-form-group"  style='width: 100%; height: 100%; padding: 6px;' onSubmit="${event => event.preventDefault()}"> 
                    <ul class="se-list-basic"> 
                        <li>
                            <div class="form-group form-material" data-plugin="formMaterial">
                                <label class="form-control-label">Agenda</label>
                                <select class="form-control" style="width: 100%; border-bottom: none;" placeholder='Select Agenda...' required>${agendas}</select>
                            </div>
                        </li>
                        <li>
                            <div class="form-group form-material floating" data-plugin="formMaterial" style="margin: auto 2px;"><label class="form-control-label">Agenda item resolution</label><input type="text" class="form-control" style="width: 100%; border-bottom: none; text-transform: none;" required /></div>
                        </li> 
                        <li>
                            <button type="submit"  class="se-btn-primary se-tooltip"> 
                                <span>Append</span> 
                                <span class="se-tooltip-inner"> 
                                    <span class="se-tooltip-text">Append resolution</span> 
                                </span> 
                            </button>
                        </li> 
                    </ul> 
                </form>  
            </div>`;

        return listDiv;
    },

    // Called after the submenu has been rendered
    on: function () {
        this.context.resolutions.textElement[1].focus();
    },

    onClick: function () {
        this.history.push(true);
        let agendaDiv = null;

        const storedSingleAgendaItemIds = JSON.parse(sessionStorage.getItem('singleAgendaItemIds'));
        const storedSingleAgendaItems = JSON.parse(sessionStorage.getItem('singleAgendaItems'));
        const storedSingleAgendaItemPositionsInMinutes = [];
        const resolutions = JSON.parse(sessionStorage.getItem('resolutions')) ?? [];

        const title = '<h4><u>Resolution</u></h4>\n';

        const value = [];
        
        this.context.resolutions.textElement.map((element) =>
            value.push(element.value)
        );

        for (let val of this.context.element.wysiwyg.children) {
            if (val.id) {
                if (value[0] === val.id) agendaDiv = val;
            }
        }
        if (value[1] && value[1].length > 0) {
            // Get resolution value
            let newTitle =  title  + '<p>' + value[1] + '</p>';

            // rendering
            const template = this.util.createElement('SPAN');
            template.innerHTML = newTitle;
            if (agendaDiv) {
                this.insertNode(template, agendaDiv)
            }

            // this.setRange(after, 1, after, 1);

            const resolutionPositionInMinutes = this.getContents().search(value[1]);
            Array.isArray(storedSingleAgendaItems) && storedSingleAgendaItems.map(item => storedSingleAgendaItemPositionsInMinutes.push(this.getContents().search(item)));

            const getAgendaItem = () => {
                if (resolutionPositionInMinutes > storedSingleAgendaItemPositionsInMinutes[storedSingleAgendaItemPositionsInMinutes.length - 1]) {
                    return storedSingleAgendaItemIds[storedSingleAgendaItemIds.length - 1];
                } else {
                    for (let i = 0; i < storedSingleAgendaItemPositionsInMinutes.length; i++) {
                        if (storedSingleAgendaItemPositionsInMinutes[i] > resolutionPositionInMinutes) {
                            const id = storedSingleAgendaItemPositionsInMinutes[i - 1] || storedSingleAgendaItemPositionsInMinutes[0];
                            const index = storedSingleAgendaItemPositionsInMinutes.findIndex(item => item === id);
                            return storedSingleAgendaItemIds[index];
                        }
                    }
                }
            };

            resolutions.push({ agenda: getAgendaItem(), text: value[1] });
            sessionStorage.setItem('resolutions', JSON.stringify(resolutions));

            // clear content

            // clear content
            this.context.resolutions.textElement.map(
                (element) => (element.value = null)
            );

            // submenu off
            this.submenuOff();
            
            // focus
            this.focus();
        }
    },
    display: "flex"
};

export default resolution

    // < h2 > <u>AGENDA</u></h2 ><p> </p><h2 id="agenda_516" style="position: relative; width: max-content; display: flex; flex-direction: row;"> 
    //          1. first agenda          
    //          </h2><div><h4><u>Resolution</u></h4><p>h</p></div><p> </p>
    //          <h2 id="agenda_517" style="position: relative; width: max-content; display: flex; flex-direction: row;">          1.1. first nested agenda          </h2><p> </p><h2 id="agenda_518" style="position: relative; width: max-content; display: flex; flex-direction: row;">          2. second agenda          </h2><p> </p><h2 id="agenda_519" style="position: relative; width: max-content; display: flex; flex-direction: row;">          2.1. second nested agenda          </h2><p> 
    //     </p><h2 id="agenda_520" style="position: relative; width: max-content; display: flex; flex-direction: row;">          3. third agenda          </h2><p> </p>